/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import Colors from '@global/colors';

function RadioIcon({ selected }) {
  return (
    <View style={[styles.outer, selected && styles.outerSelected]}>
      {selected && <View style={styles.inner} />}
    </View>
  );
}

const styles = StyleSheet.create({
  outer: {
    width: 18,
    height: 18,
    borderRadius: 9,
    borderWidth: 1.5,
    borderColor: Colors.grey0,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },
  outerSelected: {
    borderColor: Colors.blue0,
    backgroundColor: Colors.blue0,
  },
  inner: {
    width: 9,
    height: 9,
    borderRadius: 4.5,
    backgroundColor: Colors.white,
  },
});

export default RadioIcon;
